module.exports = __webpack_public_path__ + "static/img/2areaB_36.c3f2095.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/2areaB_36.png
// module id = 1145
// module chunks = 1